import(/* webpackMode: "eager" */ "/app/app/indicators/biblio/areas/page.jsx");
